<template>
	<div class="mia-SiteImpressum mia-Panel panel panel-default">
		<div v-tr="'siteimpressumtitle'" class="panel-heading" />
		<div 
			v-tr="{key: 'siteimpressum', 
				'CompanyAddress': $tr('CompanyAddressBlock_NoBreaks'), 
				'FeedbackEmail': $tr('FeedbackEmail'),
			}"
			class="panel-body"
		/>
	</div>
</template>
<style lang="scss">
.mia-siteimpressum {
	a {
		color: theme.$mia-color-themeContrast;
	}
}
</style>